import React, { Component } from "react";

// import UserImage from "../../user_image";

// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faTrash } from "@fortawesome/free-solid-svg-icons";
// import DeleteView from "../../view/delete";

// import { renderErrorMessage } from "../../../helper/user_helper";

// import LocalizedStrings from "react-localization";
// import en from "../../../localization/localization-en.json";

// import {
//   deleteCommentQuestion,
//   deleteCommentRecommendations
// } from "../../../helper/comment_helper";

import ListAnswerRow from "./list_answer_row";
import ListAnswerSquare from "./list_answer_square";

// let strings = new LocalizedStrings({ en });

class ListAnswers extends Component {
  state = { deleting: false, loaded: true, errors: "" };

  componentWillUnmount() {
    if (this.deleteCall) {
      this.deleteCall.cancel();
    }
  }

  render() {
    if (!this.state.loaded) {
      return <div />;
    }

    if (this.props.row === false) {
      const self = this;
      var listCreatorAnswer = <div />;
      if (this.props.question.user_answers) {
        listCreatorAnswer = this.props.question.user_answers.map(function(
          answer
        ) {
          return (
            <ListAnswerSquare key={answer.id} answer={answer} row={false} />
          );
        });
      }
      var answers = this.props.question.answers.map(function(answer) {
        return (
          <ListAnswerSquare
            key={answer.id}
            answer={answer}
            row={self.state.row}
          />
        );
      });

      return (
        <div className="align_element answer_square_row_v2">
          {listCreatorAnswer}
          {answers}
        </div>
      );
    }
    const self = this;
    var _answers = this.props.question.answers.map(function(answer) {
      return (
        <ListAnswerRow
          key={answer.id}
          answer={answer}
          row={self.state.row}
          removeAnswer={self.props.removeAnswer}
          updateAnswer={self.props.updateAnswer}
        />
      );
    });

    return <div className="">{_answers}</div>;
  }

  // renderDelete() {
  //   if (this.props.answer.can_delete === true) {
  //     return (
  //       <div className="delete_icon" onClick={this.removeClick}>
  //         <FontAwesomeIcon className="delete_icon" icon={faTrash} />
  //       </div>
  //     );
  //   }
  // }

  // removeClick = e => {
  //   const deleting = !this.state.deleting;
  //   this.setState({ deleting });
  // };

  // renderRemove() {
  //   if (this.props.answer.can_delete === true) {
  //     return (
  //       <div className="center pt-2">
  //         {this.renderDeleteAction()}
  //         {renderErrorMessage(this.state.errors)}
  //       </div>
  //     );
  //   }
  //   return <div />;
  // }

  // renderDeleteAction() {
  //   if (this.state.deleting) {
  //     return (
  //       <DeleteView
  //         message={strings.delete_comment}
  //         delete={this.removeAction}
  //         cancel={this.removeClick}
  //       />
  //     );
  //   }
  //   return <div />;
  // }

  // removeAction = e => {
  //   this.removeClick();
  //   const self = this;
  //   this.setState({
  //     loaded: false
  //   });

  //   if (this.props.recommendation === true) {
  //     this.deleteCall = deleteCommentRecommendations(this.props.answer.id);
  //     this.deleteCall.promise
  //       .then(answer => {
  //         self.props.removeAnswer();
  //       })
  //       .catch(errors_ => {
  //         const loaded = errors_.loaded;
  //         const errors = errors_.errors;
  //         self.setState({
  //           loaded,
  //           errors
  //         });
  //       });
  //   } else {
  //     if (this.props.profileView === true) {
  //       this.props.removedView(true);
  //     }

  //     this.deleteCall = deleteCommentQuestion(this.props.answer.id);
  //     this.deleteCall.promise
  //       .then(answer => {})
  //       .catch(errors_ => {
  //         const loaded = errors_.loaded;
  //         const errors = errors_.errors;
  //         self.setState({
  //           loaded,
  //           errors
  //         });
  //         if (self.props.profileView === true) {
  //           self.props.removedView(false);
  //         }
  //       });
  //   }
  // };
}

export default ListAnswers;



// WEBPACK FOOTER //
// ./src/components/list/interface/list_answer.jsx